module.exports = __webpack_public_path__ + "img/isPro3_4.f9742aef.png";